import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import NavbarLeft from "../Components/NavbarLeft";
import ReduceTable from "./components/ReduceTable";
import ReduceTopBar from "./components/ReduceTopBar";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import ComponentLoading from "../../commonComponents/ComponentLoading";

// REDUX
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { fetchOptimizationHistory, setOptimizationHistory } from "../../redux/actions/optimizationActions";

const ReducePage = () => {
  // REDUX ACTIONS
  const dispatch = useDispatch();
  const fetchOptimizationHistory_rd = () => dispatch(fetchOptimizationHistory());
  // REDUX STATES
  const optimization_history = useSelector((state) => (state.optimization.optimization_history ? state.optimization.optimization_history : null));
  const optimization_history_filtred = useSelector((state) =>
    state.optimization.optimization_history_filtred
      ? state.optimization.optimization_history_filtred
      : state.optimization.optimization_history
      ? state.optimization.optimization_history
      : null
  );

  const optimization_data = useSelector((state) => state.optimization.optimization_data, shallowEqual); //? state.analysis.optimization_data : null)
  const setOptimizationHistory_rd = (data) => dispatch(setOptimizationHistory(data));
  const [rand_update, set_rand_update] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetch_fn() {
      setLoading(true);
      await fetchOptimizationHistory_rd();
      setLoading(false);
    }
    fetch_fn();
    setOptimizationHistory_rd(optimization_history);
  }, [optimization_data]);

  const [optimization_history_filterer, set_optimization_history_filterer] = useState(null);

  return (
    <>
      <NavbarLeft currentPage={3} />

      <ReduceTopBar optimization_history={optimization_history} set_optimization_history_filterer={set_optimization_history_filterer} set_rand_update={set_rand_update} />

      {/* <div className="mt-[110px]"> */}
      {!loading && optimization_history_filtred ? (
        <ReduceTable
          navigate_to={"ReduceAnalysis"}
          optimization_history={optimization_history_filtred}
          optimization_history_filterer={optimization_history_filterer}
          rand_update={rand_update}
          set_rand_update={set_rand_update}
        />
      ) : (
        <ComponentLoading height={35} style={"h-[400px] flex items-center justify-center"} />
      )}
      {/* </div> */}
    </>
  );
};

export default ReducePage;
